// extracted by mini-css-extract-plugin
module.exports = {"content":"PageHeaderLayout_content__OfN_-","layout":"PageHeaderLayout_layout__67yVH"};